import { Icon } from '@data-products-and-ai/react-components';
import { IconType } from '@data-products-and-ai/react-components/lib/components/DataDisplay/Icon/Icon';
import React, { useEffect, useState } from 'react';
import UploadStatusType, { UploadStatus } from '@/utils/FilesUtils';

interface ActivityListProps {
  isOpen: boolean;
  uploadingFileName?: string;
  uploadStatus?: UploadStatusType;
}
interface ActivityLog {
  status: UploadStatus;
  title: string;
  description?: string;
}

const getStatusIcon = (status: UploadStatus): IconType => {
  switch (status) {
    case UploadStatus.UPLOADED:
      return 'IconAttach';
    case UploadStatus.UPLOADING:
      return 'IconUpload';
    case UploadStatus.FAILED:
      return 'IconInformation';
    default:
      return 'IconInformation';
  }
};

//TODO: when a file is uploaded, get activity log from backend

const ActivityList: React.FC<ActivityListProps> = ({
  isOpen,
  uploadingFileName,
  uploadStatus,
}) => {
  const [activityLogs, setActivityLogs] = useState<ActivityLog[]>([]);

  useEffect(() => {
    if (uploadingFileName && uploadStatus) {
      setActivityLogs((prev) => [
        {
          status: uploadStatus.status,
          title: `File ${uploadingFileName}`,
          description: uploadStatus.description,
        },
        ...prev,
      ]);
    }
  }, [uploadStatus, uploadingFileName]);

  return (
    isOpen && (
      <div className={`activityList${isOpen ? '_open' : ''}`}>
        <div className="activityList-header">
          <h4 className="activityList-header_title">Activity</h4>
        </div>
        <div className="activityList-content">
          <div className="activityList-container">
            {activityLogs.length ? (
              <ul className="activityList-list">
                {activityLogs.map(({ status, title, description }, index) => (
                  <div className="activityList-list_item" key={index}>
                    <Icon icon={getStatusIcon(status)} iconSize={0.9} />
                    <div className="activityList-list_item-info">
                      {title}
                      <strong
                        className={
                          `activityList-list_item-info_status` +
                          (status === UploadStatus.FAILED ? '-error' : '')
                        }
                      >
                        {status}
                      </strong>
                      {description && <p style={{ whiteSpace: 'pre-line' }}>{description}</p>}
                    </div>
                  </div>
                ))}
              </ul>
            ) : (
              <div className="activityList-list_empty">
                <p className="activityList-list_empty-title">
                  Seems like this is everything for now
                </p>
              </div>
            )}
          </div>
        </div>
      </div>
    )
  );
};

export default ActivityList;
